module.exports = __webpack_public_path__ + "img/award-c.5fb04413.png";